import * as React from 'react';

import { ISanityHoursOfOperation } from '../../fragments/sanity-hours-of-operation-parts';
import { useSanityGeneralSettings } from '../../hooks/use-sanity-general-settings';
import { classNames } from '../../utils/classnames';

interface HoursOfOperationProps {
  hoursOfOperation: ISanityHoursOfOperation;
}

function HoursOfOperation({
  hoursOfOperation,
}: HoursOfOperationProps): JSX.Element | null {
  const { hours } = useSanityGeneralSettings();
  if (hoursOfOperation?.showHours !== true) return null;
  return (
    <div id="hours-of-operation" className="bg-dark">
      <div className="w-full px-4 md:mb-24 mx-auto max-w-prose lg:max-w-screen-2xl sm:px-6 lg:px-8">
        <div className="py-8">
          <h2 className="font-serif mb-4 text-4xl text-center">
            Hours of Operation
          </h2>
          <div className="w-full md:flex justify-center">
            <div className="md:flex items-center justify-evenly w-full text-center md:text-left">
              {hours.map((item) => (
                <div key={item.id} className="my-8 md:my-0">
                  <div className="font-bold mb-2">{item.days}</div>
                  <div>{item.hours}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { HoursOfOperation };
